import { withDocumentsCompletion } from "screens/Private/Broker/Projects/Detail/Templates/Comparison/Acoris/utils/documentsCompletion";

export const COMPLETION_KEYS = {
  INFO: "isInfoCompleted",
  DOCUMENTS: "isDocumentsCompleted",
};

export const STEP_PROGRESS_COMPLETE = 100;

export const shouldPersistStepCompletion = ({
  isStepCompleted,
  savedValue,
  seenCompleteInSession,
}) => {
  if (isStepCompleted === Boolean(savedValue)) return false;
  if (!isStepCompleted && savedValue && !seenCompleteInSession) return false;
  return true;
};

export const withStepCompletion = (additionalInfo, pendingByKey) => {
  const pending = pendingByKey || {};
  let next = { ...(additionalInfo || {}) };
  if (
    Object.prototype.hasOwnProperty.call(pending, COMPLETION_KEYS.DOCUMENTS)
  ) {
    next = withDocumentsCompletion(next, pending[COMPLETION_KEYS.DOCUMENTS]);
  }
  if (Object.prototype.hasOwnProperty.call(pending, COMPLETION_KEYS.INFO)) {
    next = {
      ...next,
      [COMPLETION_KEYS.INFO]: pending[COMPLETION_KEYS.INFO],
    };
  }
  return next;
};
